// import invite from '../components/invite.vue'
const appMeeting = () =>
    import ('@/layout/AppMeeting.vue')
const meetingMediator = () =>
    import ('@/views/meeting/pages/roomMediator.vue')
const meetingMember = () =>
    import ('@/views/meeting/pages/roomMember.vue')
const meetingTemporary = () =>
    import ('@/views/meeting/pages/roomTemporary.vue')
const meetingWatcher = () =>
    import ('@/views/meeting/pages/roomWatcher.vue')
const roomWatcherNoPic = () =>
  import("@/views/meeting/pages/roomWatcherNoPic.vue");
const roomWatcherNoPicnew = () =>
  import("@/views/meeting/pages/roomWatcherNoPicnew.vue");

export default {
    path: '/',
    component: appMeeting,
    sort: 2,
    meta: {
        title: '视频调解',
        //requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    children: [{
            path: '/meeting/mediator', // 调解员入口
            name: 'roommediator',
            component: meetingMediator
        },
        {
            path: '/meeting/member',
            name: 'roommember',
            component: meetingMember,
        },
        {
            path: '/meeting/meetingTemporary',
            name: 'meetingTemporary',
            component: meetingTemporary,
        },
        {
            path: '/meeting/meetingWatcher',
            name: 'meetingWatcher',
            component: meetingWatcher,
        },
        {
            path: '/meeting/roomWatcherNoPic',
            name: 'roomWatcherNoPic',
            component: roomWatcherNoPic,
        },
        {
            path: '/meeting/roomWatcherNoPicnew',       //新的TCPlayer
            name: 'roomWatcherNoPicnew',
            component: roomWatcherNoPicnew,
        }
    ]
}